import './sec8.css';

const Sec8 = () => {
    return (
        <div className="sec8-section">
            <span>Speculation and property flipping in Boston have reshaped</span>
            <span>the urban environment by driving up housing costs, accelerating</span> 
            <span>gentrification, and altering the socioeconomic composition</span>  
            <span>of neighborhoods.</span>
            
            <span className="extraPad">
                {" "}
                What story does this 'before and after' snapshot tell you?
            </span>

        </div>
        
    );
};

export default Sec8;
